export const createConditionAction = () => {
    return {
        canEdit: ({ record }) => {
            let result = false;
            if (!["waitApproveCenter"].includes(record.refStatus?.key)) {
                result = true;
            }
            return result;
        }
    };
};

export const createConditionForm = () => {
    return [
        {
            check: ({ field }) => {
                return (
                    [
                        "refUserTemp.refPersonType",
                        "refUserTemp.refCompanyType",
                        "refUserTemp.companyNameTh",
                        "refUserTemp.companyNameEn",
                        "refUserTemp.registerDate",
                        "refUserTemp.refDepartmentRegister",
                        "refUserTemp.refDepartmentRegister.nameEn"
                    ].includes(field?.key) || new RegExp(`^refUserTemp\\.addresses.*$`, "g").test(field?.key)
                );
            },
            visibleField: () => false
        },
        {
            check: ({ field }) => {
                return [
                    "refUserTemp.refDocumentTypePerson",
                    "refUserTemp.idCard",
                    "refUserTemp.refIssuedBy",
                    "refUserTemp.outDate",
                    "refUserTemp.expireDate",
                    "refUserTemp.birthDate",
                    "refUserTemp.refNationality",
                    "refUserTemp.refRace",
                    "refUserTemp.refReligion",
                    "refUserTemp.refGender",
                    "refUserTemp.refDepartment",
                    "refUserTemp.refOfficerLv",
                    "refUserTemp.refDepartment.nameEn",
                    "refUserTemp.refJobPosition.nameEn"
                ].includes(field?.key);
            },
            inputPropField: () => ({ disabled: true })
        },
        {
            check: ({ field }) => {
                return ["refUserTemp.buttonCheckIdCard"].includes(field?.key);
            },
            visibleField: () => false
        },
        {
            check: ({ field }) => {
                return [
                    "refUserTemp.refJobPosition",
                    "refUserTemp.refOfficerType",
                    "refUserTemp.refTitle",
                    "refUserTemp.firstNameTh",
                    "refUserTemp.firstNameEn",
                    "refUserTemp.middleNameTh",
                    "refUserTemp.middleNameEn",
                    "refUserTemp.lastNameTh",
                    "refUserTemp.lastNameEn",
                    "refUserTemp.mobile"
                ].includes(field?.key);
            },
            inputPropField: ({ initialModel }) => {
                let disabled = undefined;
                if (["waitApproveCenter"].includes(initialModel.refStatus?.key)) {
                    disabled = true;
                }
                return { disabled };
            }
        },
        {
            check: ({ componentKey }) => ["AttachmentInlineList"].includes(componentKey),
            inputPropField: ({ initialModel }) => {
                let viewOnly = undefined;
                let canCreate = undefined;
                let canDelete = undefined;
                if (["waitApproveCenter"].includes(initialModel.refStatus?.key)) {
                    viewOnly = true;
                    canCreate = false;
                    canDelete = false;
                }
                return { viewOnly, canCreate, canDelete };
            }
        }
    ];
};
